<template>
  <div class="overflow-auto no-scrollbar">
    <div class="flex items-center space-x-1.5">
      <slot />
      
      <ButtonBase :size="size === 'sm' ? '3xs' : '2xs'" class="shrink-0" @click="() => onSelectPreset(preset)" :is-blur="false" v-for="preset in presets.filter(p => p)">
        <span class="line-clamp-1 max-w-36 break-all" :class="[ size === 'sm' ? 'px-0' : 'px-1' ]">
          {{ preset }}
        </span>
      </ButtonBase>
      <ButtonBase :size="size === 'sm' ? '3xs' : '2xs'" class="shrink-0" color="white" @click="() => isPresetsEdit = true">
        <span class="flex items-center space-x-1" :class="[ size === 'sm' ? 'px-0' : 'px-1' ]">
          <IconBase name="cute/pen" :width="16" />
          <span>{{ $t('components.MessagesPresets.title') }}</span>
        </span>
      </ButtonBase>

      <div class="h-1 w-16 shrink-0" />
    </div>

    <PopinBase :is-active="isPresetsEdit" size="3xs" @close="() => isPresetsEdit = false" >
      <template #body>
        <div class="p-4">
          <p class="font-bold text-md mb-0.5">{{ $t('components.MessagesPresets.title') }}</p>
          <p>{{ $t('components.MessagesPresets.description') }}</p>
          
          <div class="mt-4 space-y-1.5">
            <div class="flex items-center py-2 pr-2 pl-3 rounded-md bg-light-100 dark:bg-dark-800" v-for="(preset, i) in presets">
              <InputTextarea
                class="!bg-transparent grow"
                :placeholder="$t('components.MessagesPresets.new')"
                :rows="1"
                :model-value="preset"
                @update:model-value="(v) => presets[i] = v"
              />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="p-2">
          <ButtonBase size="sm" color="white" is-full @click="onSavePresets">
            {{ $t('actions.save') }}
          </ButtonBase>
        </div>
      </template>
    </PopinBase>
  </div>
</template>

<script lang="ts" setup>
import UserStore from '@/store/user'

const props = withDefaults(defineProps<{
  size?: 'base' | 'sm'
}>(), {
  size: 'base'
})

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

const emit = defineEmits<{
  (e: 'set', v: string): void
}>()

// PRESETS

const isPresetsEdit = ref(false)
const presets = ref([
...(currentUser.value?.messagePresets ?? []),
  ...new Array(4).fill(''),
].slice(0, 4))

const onSelectPreset = (preset: string) => {
  emit('set', preset)

  useNuxtApp().$amplitude.logEvent('Presets_select', {
    message: preset
  })
}

const onSavePresets = async () => {
  isPresetsEdit.value = false

  await userStore.edit({
    messagePresets: presets.value
  })

  useNuxtApp().$amplitude.logEvent('Presets_save')
}
</script>